import React from 'react';
import { View, Text, TouchableOpacity } from 'react-native';
import ModalTitleStyles from './ModalTitle.styles';
import Icon from '../../Icon/Icon';
import theme from '../../../common/theme';

interface Props {
  title: string;
  onDismiss?: () => void;
}

const ModalTitle: React.FC<Props> = ({ title, onDismiss }) => {
  const styles = ModalTitleStyles();

  return (
    <View style={styles.container}>
      <TouchableOpacity
        testID="btn-close"
        onPress={onDismiss}
        style={styles.btnClose}
      >
        <Icon size={20} name="times" color={theme.colors.black} />
      </TouchableOpacity>
      <Text testID="mdl-title" style={styles.title}>
        {title}
      </Text>
    </View>
  );
};

export default ModalTitle;
